<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Novo Registro</div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4">
            <label><span class="required">*</span> Cargo</label>
            <input type="text" class="form-control" v-model="role.title" />
          </div>
          <div class="col-md-8">
            <label><span class="required">*</span> Descrição</label>
            <input
              type="text"
              class="form-control"
              v-model="role.description"
            />
          </div>
        </div>
        <div class="block text-right">
          <router-link to="/roles" class="btn btn-info">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-success" @click="save">
            Salvar <i class="fa fa-save"></i>
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      role: {
        title: "",
        description: "",
      },
    };
  },
  methods: {
    save: function () {
      const self = this;

      if (self.role.id) return self.edit();

      const api = this.$store.state.api + "roles";

      let fd = self.makeFormData();
      if (!fd) return;

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Cargo cadastrado com sucesso`, "success");
          this.$router.push("/roles");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    edit: function () {
      const self = this;
      const api = self.$store.state.api + "roles/" + self.role.id;

      let fd = self.makeFormData();
      if (!fd) return;

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Cargo editado com sucesso`, "success");
          this.$router.push("/roles");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    makeFormData: function () {
      const self = this;

      let fd = new FormData();

      fd.append("title", self.role.title);
      fd.append("description", self.role.description);

      if (self.role.id) {
        fd.append("id", self.role.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    getrole: function (id) {
      let self = this;
      let api = self.$store.state.api + "roles/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.role = response.data.data[0];
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getrole(id);
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Roles/Add.vue